import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=25f43a0e&scoped=true"
import script from "./ItemForm.vue?vue&type=script&lang=js"
export * from "./ItemForm.vue?vue&type=script&lang=js"
import style0 from "./ItemForm.vue?vue&type=style&index=0&id=25f43a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f43a0e",
  null
  
)

export default component.exports